import { buildTencentProperties } from './tencentSettings';
import { buildMeshyProperties } from './meshySettings';
import { buildTripoProperties } from './tripoSettings';
import { buildRodinProperties } from './rodinSettings';

export const validateSimpleGenerate = ({ imageCount, token }) => {
  if (imageCount === 0) {
    return { valid: false, message: 'Please upload an image before generating.' };
  }

  if (!token) {
    return { valid: false, message: 'Please log in to generate a 3D model.' };
  }

  return { valid: true, message: null };
};

export const buildSimplePayload = ({ provider, files, userData, meta }) => {
  const {
    name, category, tags, proxy, formats, tencentSettings, meshySettings, tripoSettings, rodinSettings,
  } = meta;

  const payload = {
    ai: true,
    aiModel: provider,
    files,
    author: userData?.data?.name,
    email: userData?.data?.email,
    contentName: name,
    categoryName: category,
    description: tags,
    proxyName: proxy,
    formats,
  };

  if (provider === 'tencent' && tencentSettings) {
    payload.tencentSettings = buildTencentProperties(tencentSettings);
  }

  if (provider === 'meshy' && meshySettings) {
    payload.meshySettings = buildMeshyProperties(meshySettings);
  }

  if (provider === 'tripo' && tripoSettings) {
    payload.tripoSettings = buildTripoProperties(tripoSettings);
  }

  if (provider === 'rodin' && rodinSettings) {
    payload.rodinSettings = buildRodinProperties(rodinSettings);
  }

  return payload;
};
